import moment from 'moment';
import { FC, useMemo } from 'react';
import { ICalendarProps } from '../../types';
import { Icons } from 'src/assets/fonts/Icons/icons';
import theme from 'src/constants/styles';
import { localeStore } from 'src/mobx/localesStore';
import Icon from 'src/view/components/Controls/Icon/Icon';
import { defaultDate, defaultDateFormat } from '~/constants/dateTime';
import './style.scss';

type TProps = Pick<ICalendarProps, 'start_date' | 'end_date' | 'maxDetail' | 'selectRange' | 'hideCloseIcon' | 'fieldClassName'>;

interface IProps extends TProps {
  calendarModalOpen: () => void;
  resetDate: () => void;
}

const CalendarField: FC<IProps> = (props: IProps): JSX.Element => {
  const startDate = useMemo((): string => {
    const startDateFormat: string = props.maxDetail === 'decade' ? 'YYYY' : defaultDateFormat;
    return moment(props.start_date).format(startDateFormat);
  }, [props.start_date, props.maxDetail]);

  const endDate = useMemo((): string => {
    if (props.end_date) {
      const endDateFormat: string = props.maxDetail === 'decade' ? 'YYYY' : defaultDateFormat;
      return moment(props.end_date).format(endDateFormat);
    }

    return defaultDate;
  }, [props.end_date, props.maxDetail]);

  return (
    <div className={`calendar-field ${props.fieldClassName || ''}`}>
      <button onClick={props.calendarModalOpen} className="calendar-field__button">
        <Icon name={Icons.Calendar} color={theme.colors.mainblue} size={20} />
      </button>

      <div className="calendar-field__placeholder" onClick={props.calendarModalOpen}>
        {props.start_date ? (
          <>
            <p className="calendar-field__text">{startDate}</p>
            {props.selectRange ? (
              <>
                <span className="calendar-field__text">&nbsp; &ndash; &nbsp;</span>
                <p className="calendar-field__text">{endDate}</p>
              </>
            ) : null}
          </>
        ) : (
          <p className="calendar-field__text mr-8">{localeStore.t('choose_date')}</p>
        )}
      </div>

      {props.start_date && !props.hideCloseIcon ? (
        <button onClick={props.resetDate} className="calendar-field__button">
          <Icon name={Icons.CloseSmall} color={theme.colors.gray2} size={16} />
        </button>
      ) : null}
    </div>
  );
};

export default CalendarField;
